import React from 'react';
import { useSelector} from 'react-redux';
import { numShortForm } from '../../helper/custom-function';
import { WalletCounter } from '../common/wallet-counter';
import { useCoinAnimation } from '../../context/CoinAnimationContext';
import { LoaderMedium } from '../loader';

function WalletMenu() {
    const { walletRef, walletBounce, floatingCredit } = useCoinAnimation();
    var walletReduxData = useSelector(state => state.stateUpdate);
    walletReduxData = walletReduxData && walletReduxData.reward_info
                        ? JSON.parse(walletReduxData.reward_info)
                        : (localStorage.getItem("reward_info")
                            ? JSON.parse(localStorage.getItem("reward_info"))
                            : null);
    return (
        <div className="pb-2 point-menu">
            <a href="/reward-points" title="points">
            <div className="d-flex align-items-center">
                {/* Badge */}
                <div className="game-medal">
                    <div className="g-medal g-medal-gold">
                        <span>
                        {walletReduxData ? numShortForm(walletReduxData.total_badges) : <LoaderMedium size={15} />}
                        </span>
                    </div>
                    <div className="g-medal-ribbon ribbon--left"></div>
                    <div className="g-medal-ribbon ribbon--right"></div>
                </div>
                {/* Points */}
                <div className="wallet-wrapper">
                <div className={`ms-2 game-point game-wallet ${walletBounce ? "wallet-bounce" : ""}`} ref={walletRef}>
                    <img src={require("../../assets/images/icon/celebrate/diamond.gif")} alt="points" />
                    <span className="ms-1">
                        {walletReduxData
                            ?
                            <WalletCounter value={walletReduxData.total_points} />
                            :
                            <LoaderMedium size={15} />
                        }
                        
                    {/* <WalletCounter value={moneyCount} /> */}
                    {/* {moneyCount} */}
                    </span>
                    {walletReduxData && (
                        <span className="text-capitalize fs-10p">(L{walletReduxData.level})</span>
                    )}
                </div>
                {floatingCredit && (
                    <div className="floating-credit">{floatingCredit}</div>
                )}
                </div>
            </div>
            </a>
        </div>
    );
}

export {WalletMenu};